import { MainLayout } from "@/components/layout/MainLayout";
import { useState, useEffect } from "react";
import OnboardingWizard from "@/components/onboarding/OnboardingWizard";
import { useOnboardingState } from "@/integrations/supabase/onboarding";
import { AnalyticsCards } from "@/components/dashboard/AnalyticsCards";
import { LiveCallsMonitor } from "@/components/dashboard/LiveCallsMonitor";
import CallLogsTable from "@/components/dashboard/CallLogsTable";

const Index = () => {
  const { onboarding } = useOnboardingState();
  const [showWizard, setShowWizard] = useState(false);

  useEffect(() => {
    if (onboarding && onboarding.status === "in_progress") setShowWizard(true);
  }, [onboarding]);

  return (
    <div>
      {showWizard && (
        <OnboardingWizard
          open={showWizard}
          onClose={() => setShowWizard(false)}
        />
      )}
      <MainLayout>
        <div className="space-y-4 sm:space-y-6">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
            <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">
              Dashboard
            </h1>
            <div className="text-sm text-muted-foreground">
              Real-time call monitoring and analytics
            </div>
          </div>

          <AnalyticsCards timeRange="30d" />
          <CallLogsTable />

          <div className="grid gap-4 sm:gap-6">
            <LiveCallsMonitor />
          </div>
        </div>
      </MainLayout>
    </div>
  );
};

export default Index;
